export default "__VITE_ASSET__d0464649__"